import { GridValidRowModel } from '@mui/x-data-grid-premium'
import { GridCellParams } from '@mui/x-data-grid-pro'
import cn from 'classnames'
import React from 'react'
import styles from 'src/components/DataGrid/cells/DataGridCell/DataGridCell.style'
import DataGridCellWrapper from 'src/components/DataGrid/cells/DataGridCellWrapper/DataGridCellWrapper'

export interface DataGridCellProps<Row extends GridValidRowModel> {
  text?: React.ReactNode
  subtext?: React.ReactNode
  icon?: React.ReactElement
  color?: 'highlight' | 'severe'
  bold?: boolean
  disabled?: boolean
  className?: string
  params: GridCellParams<Row>
}

const DataGridCell = <Row extends GridValidRowModel>(
  props: DataGridCellProps<Row>,
): React.ReactElement => {
  const alignRight = props.params.colDef.align === 'right'

  // if no text provided, try to fallback to value if it's string compliant
  const getValue = (): React.ReactNode | undefined => {
    if (props.text !== undefined) {
      return props.text
    }
    if (
      props.params.value !== undefined &&
      (typeof props.params.value === 'string' ||
        typeof props.params.value === 'number')
    ) {
      return props.params.value
    }
    return undefined
  }

  const textIsEmpty =
    getValue() === undefined ||
    (typeof props.text === 'string' && props.text.trim() === '')
  return (
    <DataGridCellWrapper
      className={props.className}
      css={styles}
      disabled={props.disabled}
      params={props.params}
    >
      <div className={cn('wrapper', props.color)}>
        {props.icon}
        <div className={cn('text-container', { bold: props.bold, alignRight })}>
          <span className={cn('text', props.color)}>
            {textIsEmpty ? '--' : getValue()}
          </span>
          {props.subtext && (
            <span className={cn('subtext', props.color)}>{props.subtext}</span>
          )}
        </div>
      </div>
    </DataGridCellWrapper>
  )
}

export default React.memo(DataGridCell)

export const renderCell = <Row extends GridValidRowModel>(
  params: GridCellParams<Row>,
) => <DataGridCell params={params} />
